<template>
  <a-modal
    title="筛选条件管理"
    :width="800"
    :visible="visible"
    @cancel="close"
    :footer="null"
  >
    <a-table
      :columns="columns"
      :data-source="tableList"
      :loading="pageParams.tableLoading"
      :pagination="false"
      row-key="id"
      :scroll="{ y: 340 }"
    >
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record, index">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(record)">删除</a>
          </span>
          <span v-else-if="item.dataIndex === 'goTop'">
            <a-icon type="arrow-up" class="top-bottom" @click="goTop(record, index)" />
          </span>
          <span v-else-if="item.dataIndex === 'goBottom'">
            <a-icon type="arrow-down" class="top-bottom" @click="goBottom(record, index)" />
          </span>
          <span v-else-if="item.type === 'switch'">
            <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusOnChange(record, item.dataIndex)" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
    <Page v-show="false" ref="pageModal" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
import { apiScpScreeningSchemeDeleteScheme, apiScpScreeningSchemeUpdateScheme } from '@/api/scp/factoryCallMaterial/rawMaterialPlan'
// 表单字段
export default {
  props: {},
  data () {
    return {
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpScreeningScheme/searchAllScheme',
        tableLoading: false,
        pageSize: 10000
      },
      visible: false,
      columns: [
        {
          title: '按钮名称',
          dataIndex: 'schemeName'
        },
        {
          title: '按钮说明',
          dataIndex: 'schemeExplain'
        },
        {
          title: '默认方案',
          dataIndex: 'defaultFlag',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'defaultFlag' },
          type: "switch"
        },
        {
          title: '上移',
          width: 70,
          dataIndex: 'goTop',
          scopedSlots: { customRender: 'goTop' },
          align: 'center'
        },
        {
          title: '下移',
          width: 70,
          dataIndex: 'goBottom',
          scopedSlots: { customRender: 'goBottom' },
          align: 'center'
        },
        {
          title: '操作',
          width: 70,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      queryParams: {
        menuId: this.$route.meta.menuId
      },
      tableList: [],
      timer: null
    }
  },
  created () {},
  methods: {
    show () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.pageModal.getFirstPage(this.queryParams)
      })
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data
    },
    // 关闭模态框
    close () {
      this.reset()
      this.$emit('handle-success')
      this.visible = false
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    // 删除
    handleDelete (row) {
      const self = this
      this.$confirm({
        title: '你确定要删除这行内容吗?',
        content: "",
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpScreeningSchemeDeleteScheme(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.$refs.pageModal.getFirstPage(self.queryParams)
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    statusOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
      this.updateTable(record, "switch")
    },
    // 修改
    updateTable (record, flag) {
      const params = {
        id: record.id,
        schemeDetailJson: record.schemeDetailJson,
        bangingMenu: this.$route.meta.menuId
      }
      if (flag === "switch") {
        params.defaultFlag = record.defaultFlag
      }
      if (flag === "sort") {
        params.sort = record.sort
      }
      apiScpScreeningSchemeUpdateScheme(params).then(response => {
        if (response.code === 200) {
          this.$message.success('修改成功')
        } else {
          this.$message.error(response.msg)
        }
        this.$refs.pageModal.getFirstPage(this.queryParams)
      }).catch(e => {
        this.$refs.pageModal.getFirstPage(this.queryParams)
      })
    },
    // 向上
    goTop (record, index) {
      if (index === 0) {
        return
      }

      // 防抖节流
      if (this.timer) {
        return
      }
      this.timer = setTimeout(() => {
        this.timer = null
        record.sort -= 1
        this.updateTable(record, "sort")
      }, 500)
    },
    // 向下
    goBottom (record, index) {
      if (this.tableList.length - 1 === index) {
        return
      }

      // 防抖节流
      if (this.timer) {
        return
      }
      this.timer = setTimeout(() => {
        this.timer = null
        record.sort += 1
        this.updateTable(record, "sort")
      }, 500)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body {
  height: 450px;
  overflow-y: scroll;
}
.top-bottom {
  color: #0486fe;
  cursor: pointer;
}
</style>
